export default __webpack_public_path__ + "static/media/warning-error.1822e93e.svg";